import { useTranslation } from "react-i18next";

export default NeedToTrainFirstLink;

const href = "https://www.redhat.com/en/services/training/all-courses-exams";
function NeedToTrainFirstLink() {
  const { t } = useTranslation("need-to-train-first-link");
  return <a href={href}>{t("name")}</a>;
}
